export const getRelative = /* GraphQL */ `
  query GetRelative($id: ID!, $sk: String!) {
    getResource(id: $id, sk: $sk) {
      id
      sk
      workspaceId
      schemaVersion
      relationship
      resource {
        id
        sk
        workspaceId
        schemaVersion
        name
        description
        tags {
          key
          type
          value
        }
        createdAt
        updatedAt
      }
      updatedAt
    }
  }
`;

export const listRelatives = /* GraphQL */ `
  query ListRelatives(
    $id: ID!
    $sk: ModelStringKeyConditionInput!
    $limit: Int
    $nextToken: String
  ) {
    listResources(id: $id, sk: $sk, limit: $limit, nextToken: $nextToken) {
      items {
        id
        sk
        workspaceId
        schemaVersion
        relationship
        resource {
          id
          sk
          workspaceId
          schemaVersion
          name
          bankId
          description
          tags {
            key
            type
            value
          }
          createdAt
          updatedAt
        }
        updatedAt
      }
    }
  }
`;
